import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";

import userReducer from "./user/state";
import searchReducer from "./search/state";
import mapReducer from "./map/state";
import mapContentReducer from "./map-content/state";
import galleryReducer from "./gallery/state";
import reviewReducer from "./review/state";
import sharePositionReducer from "./share-position/state";
import detailReducer from "./detail/state";
import contentReducer from "./content/state";
import reportReducer from "./report/state";
import mymapsReducer from "./mymaps/state";

const reducer = combineReducers({
	user: userReducer,
	search: searchReducer,
	map: mapReducer,
	mapContent: mapContentReducer,
	reviewPopupState: reviewReducer,
	sharePosition: sharePositionReducer,
	detail: detailReducer,
	gallery: galleryReducer,
	content: contentReducer,
	report: reportReducer,
	mymaps: mymapsReducer,
});

export type IState = ReturnType<typeof reducer>;

// nahodime Redux store
export const store = configureStore({
	reducer,
});

export type IStore = typeof store;
export type IDispatch = typeof store.dispatch;
